import React, { useEffect, useState } from 'react'
import styles from './index.module.sass'
import { Search } from '../../ui/Search'
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs'
import info from '../../../svg-icons/infoSVG.svg'
import fire from '../../../svg-icons/fire.svg'
import prev from '../../../assets/arrow_prev.svg'
import next from '../../../assets/arrow_next.svg'
import { getTimeFromTimestamp, round } from '../../../utils'
import { Transaction } from '../../../app/models/generated'
import classNames from 'classnames'
import ProgressBar from '../../ui/ProgressBar'
import { NavLink, useNavigate, useParams } from 'react-router-dom'
import { initialTransaction } from '../../../app/models/generated/models/Transaction'
import { TokenTransferItems } from './TokenTransferItems'
import { Status } from '../../ui/Status'
import expend_svg from '../../../assets/expend.svg'
import arrow_icon from '../../../assets/arrow_icon.svg'
import {
    getTokenTransfers, 
    getTransaction,
    TokenTransferList,
} from '../../../services/TransactionPageService'
import { Icon } from '../../ui/Icon'

const previousParams: Record<string, string>[] = []
let currentParams: Record<string, string> = {}
let page = 1

export const TransactionPage = () => {
    const navigate = useNavigate()
    const { address } = useParams()

    const [transaction, setTransactions] =
        useState<Transaction>(initialTransaction)
    const [tokenTransfers, setTokenTransfers] = useState<TokenTransferList>({
        items: [],
        next_page_params: null,
    })

    useEffect(() => {
        getTransaction(setTransactions, address, navigate)
    }, [])

    useEffect(() => {
        getTokenTransfers(setTokenTransfers, address, {})
    }, [])

    const isDisabled = page == 1

    const previousPageHandler = () => {
        if (previousParams.length > 0) {
            page = page - 1
            currentParams = previousParams.pop() || {}
            getTokenTransfers(setTokenTransfers, address, currentParams)
        }
    }
    const nextPageHandler = () => {
        if (tokenTransfers.next_page_params) {
            previousParams.push(currentParams)
            currentParams = tokenTransfers.next_page_params
            page = page + 1
            getTokenTransfers(setTokenTransfers, address, currentParams)
        }
    }

    const value =
        transaction.value === '0'
            ? 0
            : round(Number(transaction.fee?.value) / 10 ** 18, 12)
    const transactionFee = round(Number(transaction.fee?.value) / 10 ** 18, 12)
    const gasPrice = (Number(transaction.gas_price) / 10 ** 18).toFixed(18)
    const gasLimit = Number(transaction.gas_limit)
        ? Number(transaction.gas_limit)
        : 0
    const gasUsed = Number(transaction.gas_used)
        ? Number(transaction.gas_used)
        : 0
    const percentage = Number(
        (
            (Number(transaction.gas_used) / Number(transaction.gas_limit)) *
            100
        ).toFixed(2)
    )
    const baseFee = (Number(transaction.base_fee_per_gas) / 10 ** 9).toFixed(10)
    const maxFee = (Number(transaction.max_fee_per_gas) / 10 ** 9).toFixed(10)
    const maxPriority = (
        Number(transaction.max_priority_fee_per_gas) /
        10 ** 9
    ).toFixed(10)
    const burntFees = (Number(transaction.tx_burnt_fee) / 10 ** 18).toFixed(18)
    return (
        <div>
            <section className={styles.pageSection}>
                <div className={styles.headOfPage}>
                    <p>Transaction details</p>
                </div>
                <Tabs>
                    <TabList>
                        <Tab>Overview</Tab>
                        <Tab>Log(1)</Tab>
                        <Tab>State</Tab>
                    </TabList>

                    <TabPanel>
                    <div className={styles.blockdetail}>
                        <div className={styles.details}>
                            <div className={styles.infoRow}>
                                <span data-hint='Unique character string (TxID) assigned to every verified transaction'>
                                    <Icon icon='infoSVG' width={24} height={24} color={'white'} />
                                </span>
                                <p className={styles.rowTitle}>
                                    Transaction hash: 
                                </p>
                                <p>{transaction.hash}</p>
                            </div>
                            <div className={styles.infoRow}>
                                <span data-hint='Current transaction state: Success, Failed (Error), or Pending (In Process)'>
                                    <Icon icon='infoSVG' width={24} height={24} color={'white'} />
                                </span>
                                <p className={styles.rowTitle}>Status: </p>
                                <p className={styles.percentageGreen}>{transaction.status}</p>
                            </div>
                            <div className={styles.infoRow}>
                                <span data-hint='Block number containing the transaction'>
                                    <Icon icon='infoSVG' width={24} height={24} color={'white'} />
                                </span>
                                <p className={styles.rowTitle}>Block: </p>
                                <NavLink to={'/block/' + transaction.block} className={styles.rowLink}>
                                    <span>{transaction.block}</span>
                                </NavLink>
                                <span>137 Block Confirmations</span>
                            </div>
                            <div className={styles.infoRow}>
                                <span data-hint='Date & time of transaction inclusion, including length of time for confirmation'>
                                    <Icon icon='infoSVG' width={24} height={24} color={'white'} />
                                </span>
                                <p className={styles.rowTitle}>Timestamp: </p>
                                <p>
                                    {/* {transaction.timestamp
                                        ? getTimeFromTimestamp(
                                              transaction.timestamp
                                          )
                                        : ''} */}
                                {/* change the value of timestamp */}
                                    {transaction.timestamp}
                                </p>
                            </div>
                            <div className={styles.line}></div>
                            
                            <div className={styles.infoRow}>
                                <span data-hint='Address (external or contract) receiving the transaction'>
                                    <Icon icon='lightening' width={24} height={24} color={'white'} />
                                </span>
                                <p className={styles.rowTitle}>To</p>
                                <p>Transfer5,469.486401 USDT To </p>
                                <NavLink
                                    to={'/address/' + transaction.to?.hash}>
                                    {transaction.to?.hash}
                                </NavLink>
                            </div>
                            <div className={styles.line}></div>

                            <div className={styles.infoRow}>
                                <span data-hint='Unique character string (TxID) assigned to every verified transaction'>
                                    <Icon icon='infoSVG' width={24} height={24} color={'white'} />
                                </span>
                                <p className={styles.rowTitle}>
                                    Sponsored:
                                </p>
                                <p>-----------------</p>
                            </div>
                            <div className={styles.line}></div>
                            
                            <div className={styles.infoRow}>
                                <span data-hint='Address (external or contract) sending the transaction'>
                                    <Icon icon='infoSVG' width={24} height={24} color={'white'} />
                                </span>
                                <p className={styles.rowTitle}>From: </p>
                                <NavLink
                                    to={
                                        '/address/' + transaction.from?.hash
                                    }>
                                    {transaction.from?.hash}
                                </NavLink>
                            </div>
                            
                            <div className={styles.infoRow}>
                                <span data-hint='Address (external or contract) sending the transaction'>
                                    <Icon icon='infoSVG' width={24} height={24} color={'white'} />
                                </span>
                                <p className={styles.rowTitle}>Interacted With (To): </p>
                                {/* change the value of this field */}
                                <p>0xdAC17F958D2ee523a2206206994597C13D831ec7 (Tether: USDT Stablecoin)</p>
                            </div>
                        
                            <div className={styles.line}></div>
                            
                            <div className={styles.infoRow}>
                                <span data-hint='Address (external or contract) sending the transaction'>
                                    <Icon icon='infoSVG' width={24} height={24} color={'white'} />
                                </span>
                                <p className={styles.rowTitle}>ERC-20 Tokens Transferred: </p>
                                {/* change the value of this field */}
                                <p>22,025,740 (73.4From 0x3B9fc9...e08C7b08 To 0x707055...A51F7b68 For 5,469.486401<br/> ($5,460.67) Tether USD... (USDT...)2%) +47% Gas Target</p>
                            </div>
                            
                            
                            <div className={styles.line}></div>

                            <div className={styles.infoRow}>
                                <span data-hint=' Value sent in the native token (and USD) if applicable'>
                                    <Icon icon='infoSVG' width={24} height={24} color={'white'} />
                                </span>
                                <p className={styles.rowTitle}>Value: </p>
                                <span>{value}</span>
                                {/* change the value of this field */}
                                <span className={styles.valueType}>ETH</span>
                            </div>
                            <div className={styles.infoRow}>
                                <span data-hint='Total transaction fee'>
                                    <Icon icon='infoSVG' width={24} height={24} color={'white'} />
                                </span>
                                <p className={styles.rowTitle}>
                                    Transaction fee:
                                </p>
                                <span>{transactionFee}</span>
                                {/* change the value of this field */}
                                <span className={styles.valueType}>ETH</span>
                            </div>
                            <div className={styles.infoRow}>
                                <span data-hint='Price per unit of gas specified by the sender. Higher gas prices can prioritize
                                 transaction inclusion during times of high usage'>
                                    <Icon icon='infoSVG' width={24} height={24} color={'white'} />
                                </span>
                                <p className={styles.rowTitle}>Gas price:</p>
                                <span>{gasPrice}</span>
                                <span className={styles.valueType}>ETH</span>
                            </div>
                        </div>

                        <div className={styles.details}>
                            <div className={styles.infoRow}>
                                <span data-hint='Actual gas amount used by the transaction'>
                                    <Icon icon='infoSVG' width={24} height={24} color={'white'} />
                                </span>
                                <p className={styles.rowTitle}>
                                    Gas limit & usage by txn:
                                </p>
                                {/* <div className={styles.percentage}>
                                    <span>{gasLimit}</span>
                                    <div className={styles.verticalLine}></div>
                                    <span>{gasUsed}</span>
                                    <ProgressBar
                                        progressColor={'#3CE2EC'}
                                        bgColor={'#8D8D8E'}
                                        progress={percentage}
                                        width={39}
                                        height={3}></ProgressBar>
                                    <span>{percentage}%</span>
                                </div> */}
                                {/* change the value of this field */}
                                <p>94,831 | 58,421 (61.61%)</p>
                            </div>
                            <div className={styles.infoRow}>
                                <span data-hint='Base Fee refers to the network Base Fee at the time of the block, while
                                Max Fee & Max Priority Fee refer to the max amount a user is willing to pay for their tx & to give to the limit miner respectively'>
                                    <Icon icon='infoSVG' width={24} height={24} color={'white'} />
                                </span>
                                <p className={styles.rowTitle}>
                                    Gas fees: 
                                </p>
                                <span className={styles.mgR20}>
                                    Base: {baseFee} Gwei
                                </span>
                                <div className={styles.verticalLine}></div>
                                <span className={styles.mgR20}>
                                    Max:{maxFee} Gwei
                                </span>
                                <div className={styles.verticalLine}></div>
                                <span className={styles.mgR20}>
                                    Max priority: {maxPriority} Gwei
                                </span>
                            </div>
                            <div className={styles.infoRow}>
                                <span data-hint='Amount of THE burned for this transaction. Equals Block Base Fee per Gas * Gas Used'>
                                    <Icon icon='infoSVG' width={24} height={24} color={'white'} />
                                </span>
                                <p className={styles.rowTitle}>Burnt & Txn Savings Fees:</p>
                                {/* <span>{burntFees}</span> */}
                                {/* <span className={styles.valueType}>ETH</span> */}
                                {/* change of this value */}
                                <span>🔥Burnt:0.001477090267948427 ETH ($2.73)|💸Txn Savings:0.000375796433061192 ETH($0.69)</span>
                            </div>
                            
                            <div className={styles.line}></div>

                            <div className={styles.infoRow}>
                                <span data-hint='Price per unit of gas specified by the sender. Higher gas prices can prioritize
                                 transaction inclusion during times of high usage'>
                                    <Icon icon='infoSVG' width={24} height={24} color={'white'} />
                                </span>
                                <p className={styles.rowTitle}>Other Attributes:</p>
                                {/* change value of this field */}
                                <span>Txn Type: 2 (EIP-1559) | Nonce: 5 | Position In Block: 142</span>
                            </div>

                            <div className={styles.infoRow}>
                                <span data-hint='Price per unit of gas specified by the sender. Higher gas prices can prioritize
                                 transaction inclusion during times of high usage'>
                                    <Icon icon='infoSVG' width={24} height={24} color={'white'} />
                                </span>
                                <p className={styles.rowTitle}>Input Data: </p>
                                {/* change value of this field */}
                                <div>
                                    <p>Function: transfer(address _to, uint256 _value)<br/>MethodID: 0xa9059cbb
                                    <br/>[0]:  000000000000000000000000707055d460b4b3c9a95a2e4f6dd79b3ca51
                                    <br/>[1]:  00000000000000000000000000000000000000000000000000000001460</p>

                                    <button className = {styles.signInButton}>
                                        View Input As
                                        <span>  </span>
                                        <Icon icon='expend_svg' width={10} height={10} color={'black'}/>
                                    </button>
                                    <button className = {styles.signInButton}>
                                        Decode Input Data
                                    </button>
                                    <button className = {styles.signInButton}>
                                        Advanced Filter
                                    </button>
                                </div>
                            </div>

                        </div>
                    </div>
                    </TabPanel>

                    <TabPanel>
                        <div className={styles.details}>
                            <h1 className={styles.transfont1}>Transaction Receipt Event Logs</h1> 
                            <div className={styles.specrow}>
                                <div className={styles.infoRow}>
                                    <p className={styles.rowTitle}>Name</p>
                                    {/* change the value of this field */}
                                    <span>Transfer (index_topic_1 address from, index_topic_2 address to, uint256 value)View Source</span>
                                </div>
                                <div className={styles.infoRow}>
                                    <p className={styles.rowTitle}>Topics</p>
                                    <div>
                                        <div className={styles.pairfont}>
                                            <div className={styles.specialfont}>0 </div> 
                                            <div>0xddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef</div>
                                        </div>
                                        <div className={styles.pairfont}>
                                            <div className={styles.specialfont}>1 </div> 
                                            <img
                                                src={arrow_icon}
                                                alt="arrow_icon"
                                            />
                                            <div>
                                                Dec
                                                <span>  </span>
                                                <Icon icon='expend_svg1' width={10} height={10} color={'black'}/>
                                            </div>
                                            <div>0x3B9fc9f319B478Ae2014293c2703a176e08C7b08</div>
                                        </div>
                                        <div className={styles.pairfont}>
                                            <div className={styles.specialfont}>2 </div> 
                                            <img
                                                src={arrow_icon}
                                                alt="arrow_icon"
                                            />
                                            <div>
                                                Dec
                                                <span>  </span>
                                                <Icon icon='expend_svg1' width={10} height={10} color={'black'}/>
                                            </div>
                                            <div>0x707055D460B4b3c9a95a2e4F6dD79b3cA51F7b68</div>
                                        </div>
                                    </div>    
                                </div>
                                <div className={styles.infoRow}>
                                    <p className={styles.rowTitle}>Data</p>
                                    {/* change the value of this field */}
                                    <div className={styles.paircontent}>
                                        <div>value :5469486401</div>
                                        <div>
                                            <button className = {styles.signInButton1}>
                                                Dec
                                            </button>
                                            <button className = {`${styles.signInButton1} ${styles.disableButton}`}>
                                                Hex
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                       
                        {/* {tokenTransfers.items.length == 0 ? (
                            <p className={styles.message}>
                                There are no token transfers.
                            </p>
                        ) : (
                            <div className={styles.transactions}>
                                <div className={styles.paginationButtons}>
                                    <button
                                        className={styles.controlButton}
                                        disabled={isDisabled}
                                        onClick={previousPageHandler}>
                                        <img src={prev} alt="previous page" />
                                    </button>
                                    <div className={styles.pageNum}>{page}</div>
                                    <button
                                        className={styles.controlButton}
                                        disabled={
                                            !tokenTransfers.next_page_params
                                        }
                                        onClick={nextPageHandler}>
                                        <img src={next} alt="next page" />
                                    </button>
                                </div>
                                <div className={styles.tableWrapper}>
                                    <div className={styles.tableBorder}></div>
                                    <table className={styles.table}>
                                        <thead className={styles.tableHead}>
                                            <tr>
                                                <th
                                                    className={classNames(
                                                        styles.thW30,
                                                        styles.thDefault
                                                    )}>
                                                    Token
                                                </th>
                                                <th
                                                    className={classNames(
                                                        styles.thW30,
                                                        styles.thDefault
                                                    )}>
                                                    Token ID
                                                </th>
                                                <th
                                                    className={classNames(
                                                        styles.thFrom,
                                                        styles.thDefault
                                                    )}>
                                                    From
                                                </th>
                                                <th
                                                    className={
                                                        styles.thIcon
                                                    }></th>
                                                <th className={styles.thTo}>
                                                    To
                                                </th>
                                                <th
                                                    className={classNames(
                                                        styles.thW40,
                                                        styles.thDefaultRight
                                                    )}>
                                                    Value
                                                </th>
                                            </tr>
                                        </thead>
                                        <TokenTransferItems
                                            TokenTransferArray={
                                                tokenTransfers.items
                                            }></TokenTransferItems>
                                    </table>
                                </div>
                            </div>
                        )} */}
                    </TabPanel>
                    <TabPanel>
                        <div className={styles.tableform}>
                            <div className={styles.trform}>
                                <div className={styles.thform}>
                                    <div>
                                        Address
                                        <span> </span>
                                        <Icon icon='dynamicarrow' width={10} height={12} color='white'></Icon>
                                    </div>
                                </div>
                                <div className={styles.thform}>
                                    <div>
                                        Before
                                        <span> </span>
                                        <Icon icon='dynamicarrow' width={10} height={12} color='white'></Icon>
                                    </div>
                                </div>
                                <div className={styles.thform}>
                                    <div>
                                        After
                                        <span> </span>
                                        <Icon icon='dynamicarrow' width={10} height={12} color='white'></Icon>
                                    </div>
                                </div>
                                <div className={styles.thform}>
                                    <div>
                                        State Difference
                                        <span> </span>
                                        <Icon icon='dynamicarrow' width={10} height={12} color='white'></Icon>
                                    </div>
                                </div> 
                            </div>
                            <div className={styles.trform}>
                                <div className={styles.thform}>0x3B9fc9...e08C7b08</div>
                                <div className={styles.thform}>
                                    <div>0.018033344549502508 Eth</div>
                                    <div> Nonce: 5</div>
                                </div>
                                <div className={styles.thform}>
                                    <div>0.018033344549502508 Eth</div>
                                    <div> Nonce: 5</div>
                                </div>
                                <div className={styles.thform}>0.001479031243864009</div>                      
                            </div>
                            <div className={styles.trform}>
                                <div className={styles.thform}>0xcDBF58...dE858321 Miner</div>
                                <div className={styles.thform}>71,619.487080962057260365 ETH</div>  
                                <div className={styles.thform}>71,619.487082903033175947 ETH</div>   
                                <div className={styles.thform}>0.001479031243864009</div>                     
                            </div>
                            <div className={styles.trform}>
                                    <div className={styles.thform}>0xdAC17F...3D831ec7</div>
                                    <div className={styles.thform}>USDT</div>       
                                    <div className={styles.thform}></div>       
                                    <div className={styles.itemright}><Icon icon='uparrow' width={13} height={7} color='white'></Icon></div>
                            </div>
                            <div className={styles.bigform}>
                            <div className={styles.storageform}>
                                Storage (2)
                                    <div className={styles.infoRow1}>
                                        <div className={styles.pairfont}>
                                            <div className={styles.width20}>Storage Address: </div> 
                                            <div className={styles.width80}>0xddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef</div>
                                        </div>
                                        <div className={styles.pairfont}>
                                            <div className={styles.width20}>Before: </div> 
                                            <div className={styles.greyform}>
                                                Hex
                                                <span>  </span>
                                                <Icon icon='expend_svg1' width={10} height={10} color={'black'}/>
                                            </div>
                                            
                                            <img
                                                src={arrow_icon}
                                                alt="arrow_icon"
                                            />
                                            
                                            <div>0x00000000000000000000000000000000000000000014601bd41</div>
                                        </div>
                                        <div className={styles.pairfont}>
                                            <div className={styles.width20}>After: </div> 
                                            <div className={styles.greyform}>
                                                Hex
                                                <span>  </span>
                                                <Icon icon='expend_svg1' width={10} height={10} color={'black'}/>
                                            </div>
                                            
                                            <img
                                                src={arrow_icon}
                                                alt="arrow_icon"
                                            />
                                            
                                            <div>0x00000000000000000000000000000000000000000014601bd41</div>
                                        </div>
                                    </div>

                                    <div className={styles.infoRow1}>
                                        <div className={styles.pairfont}>
                                            <div className={styles.width20}>Storage Address: </div> 
                                            <div className={styles.width80}>0xddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef</div>
                                        </div>
                                        <div className={styles.pairfont}>
                                            <div className={styles.width20}>Before: </div> 
                                            <div className={styles.greyform}>
                                                Hex
                                                <span>  </span>
                                                <Icon icon='expend_svg1' width={10} height={10} color={'black'}/>
                                            </div>
                                            
                                            <img
                                                src={arrow_icon}
                                                alt="arrow_icon"
                                            />
                                            
                                            <div>0x00000000000000000000000000000000000000000014601bd41</div>
                                        </div>
                                        <div className={styles.pairfont}>
                                            <div className={styles.width20}>After: </div> 
                                            <div className={styles.greyform}>
                                                Hex
                                                <span>  </span>
                                                <Icon icon='expend_svg1' width={10} height={10} color={'black'}/>
                                            </div>
                                            
                                            <img
                                                src={arrow_icon}
                                                alt="arrow_icon"
                                            />
                                            
                                            <div>0x00000000000000000000000000000000000000000014601bd41</div>
                                        </div>
                                    </div>
                            </div>
                        </div>
                        </div>
                    </TabPanel>
                </Tabs>
            </section>
        </div>
    )
}
